<template>
	<div class="joinus">
		<div class="jubannerimg"><img :src="banner.image"></div>
		<div class="content">
			<el-tabs v-model="pageName" @tab-click="handleClick" >

			    <el-tab-pane label="成为合作商" name="ranchisee" class="joinjs jmsbox"></el-tab-pane>
			    <el-tab-pane label="成为经销商" name="distributor" class="joinjs jxsbox">
				<!--	<div>
						<div class="ruletit">加盟规则</div>
						<div class="rulecontent">
							<div class="pline1"></div>
							<div class="pline2"></div>
							<div class="pline3"></div>
							<div class="inline rulebox">
								<img src="../assets/images/icon-08.png" />
								<p class="rulemsg">丰富的人员管理经验</p>
							</div>
							<div class="inline rulebox">
								<img src="../assets/images/icon-09.png" />
								<p class="rulemsg">理解餐饮、零售行业的运作模式</p>
							</div>
							<div class="inline rulebox">
								<img src="../assets/images/icon-10.png" />
								<p class="rulemsg">具有良好的商业意识和抗风险能力</p>
							</div>
							<div class="inline rulebox">
								<img src="../assets/images/icon-11.png" />
								<p class="rulemsg">认同聚宝源文化</p>
							</div>
							<div class="inline rulebox">
								<img src="../assets/images/icon-12.png" />
								<p class="rulemsg">具备发展多家店的潜质</p>
							</div>
							<div class="inline rulebox">
								<img src="../assets/images/icon-13.png" />
								<p class="rulemsg">有良好的财务基础</p>
							</div>
						</div>
					</div>
					<div class="boxmarg">
						<div class="ruletit">加盟流程</div>
						<div class="joinline">
							<div class="stepLine1 stepLine"></div>
							<div class="stepLine2 stepLine"></div>
							<div class="stepLine3 stepLine"></div>
							<div class="stepLine4 stepLine"></div>
							<div class="linebox">
								<img src="../assets/images/icon-14.png" />
								<div class="linetit">提交申请</div>
								<div class="stepbox">
									<p class="stepmsg">聚宝源官网</p>
									<p class="stepmsg">在线提交申请</p>
									<p class="stepmsg">电话沟通</p>
								</div>
							</div>
							<div class="linebox">
								<img src="../assets/images/icon-15.png" />
								<div class="linetit">加盟商面试</div>
								<div class="stepbox">
									<p class="stepmsg">餐厅参观</p>
									<p class="stepmsg">面试评估</p>
									<p class="stepmsg">支付意向金</p>
								</div>
							</div>
							<div class="linebox">
								<img src="../assets/images/icon-16.png" />
								<div class="linetit">选址评估</div>
								<div class="stepbox">
									<p class="stepmsg">选址，新址评审</p>
									<p class="stepmsg">签订加盟合同</p>
									<p class="stepmsg">支付开店服务和首期费</p>
								</div>
							</div>
							<div class="linebox">
								<img src="../assets/images/icon-17.png" />
								<div class="linetit">新店筹备</div>
								<div class="stepbox">
									<p class="stepmsg">新店设计&装修</p>
									<p class="stepmsg">人员招募培训+运营全套资料</p>
									<p class="stepmsg">菜单审批，物料/设施/设备订购</p>
								</div>
							</div>
							<div class="linebox">
								<img src="../assets/images/icon-18.png" />
								<div class="linetit">新店筹备</div>

							</div>
						</div>
						<div class="formbox">
							<div class="ruletit">加盟在线申请</div>
							<div class="formmsg">感谢您对聚宝源品牌的关注和支持，如有意愿加盟聚宝源品牌，请填写书面申请，提供以下信息3个工作日内我们会电话和您洽谈。（*号为必填）</div>
							<div class="formcontent">
								<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="20px" class="demo-ruleForm">
								  <el-form-item label=" " prop="name">
								    <el-input v-model="ruleForm.name" placeholder="您的姓名"></el-input>
								  </el-form-item>
								  <el-form-item label=" " prop="tel">
								    <el-input v-model="ruleForm.tel" placeholder="联系电话"></el-input>
								  </el-form-item>
								  <el-form-item label=" " prop="email">
								    <el-input v-model="ruleForm.email" placeholder="E-mail"></el-input>
								  </el-form-item>
								  <el-form-item label=" " prop="city">
								    <el-input v-model="ruleForm.city"placeholder="意向加盟的城市"></el-input>
								  </el-form-item>
								  <el-form-item label=" " prop="cost">
								    <el-input v-model="ruleForm.cost" placeholder="预期投资金额:200-400(万元)"></el-input>
								  </el-form-item>
								  <el-form-item label=" " prop="describe">
								    <el-input type="textarea" :rows="4" v-model="ruleForm.describe" placeholder="最近从事的职业(请从简描述)"></el-input>
								  </el-form-item>
								  <el-form-item>
								     <el-button @click="submit('ruleForm')">提&nbsp;&nbsp;&nbsp;交</el-button>
								   </el-form-item>
								</el-form>
							</div>

						</div>
					</div>	-->
				</el-tab-pane>
			    <el-tab-pane label="成为供应商" name="supplier" class="joinjs gysbox">
					<!--<div>
						<div class="ruletit">加盟规则</div>
						<div class="rulecontent">
							<div class="pline1"></div>
							<div class="pline2"></div>
							<div class="pline3"></div>
							<div class="inline rulebox">
								<img src="../assets/images/icon-08.png" />
								<p class="rulemsg">丰富的人员管理经验</p>
							</div>
							<div class="inline rulebox">
								<img src="../assets/images/icon-09.png" />
								<p class="rulemsg">理解餐饮、零售行业的运作模式</p>
							</div>
							<div class="inline rulebox">
								<img src="../assets/images/icon-10.png" />
								<p class="rulemsg">具有良好的商业意识和抗风险能力</p>
							</div>
							<div class="inline rulebox">
								<img src="../assets/images/icon-11.png" />
								<p class="rulemsg">认同聚宝源文化</p>
							</div>
							<div class="inline rulebox">
								<img src="../assets/images/icon-12.png" />
								<p class="rulemsg">具备发展多家店的潜质</p>
							</div>
							<div class="inline rulebox">
								<img src="../assets/images/icon-13.png" />
								<p class="rulemsg">有良好的财务基础</p>
							</div>
						</div>
					</div>
					<div class="boxmarg">
						<div class="ruletit">加盟流程</div>
						<div class="joinline">
							<div class="stepLine1 stepLine"></div>
							<div class="stepLine2 stepLine"></div>
							<div class="stepLine3 stepLine"></div>
							<div class="stepLine4 stepLine"></div>
							<div class="linebox">
								<img src="../assets/images/icon-14.png" />
								<div class="linetit">提交申请</div>
								<div class="stepbox">
									<p class="stepmsg">聚宝源官网</p>
									<p class="stepmsg">在线提交申请</p>
									<p class="stepmsg">电话沟通</p>
								</div>
							</div>
							<div class="linebox">
								<img src="../assets/images/icon-15.png" />
								<div class="linetit">加盟商面试</div>
								<div class="stepbox">
									<p class="stepmsg">餐厅参观</p>
									<p class="stepmsg">面试评估</p>
									<p class="stepmsg">支付意向金</p>
								</div>
							</div>
							<div class="linebox">
								<img src="../assets/images/icon-16.png" />
								<div class="linetit">选址评估</div>
								<div class="stepbox">
									<p class="stepmsg">选址，新址评审</p>
									<p class="stepmsg">签订加盟合同</p>
									<p class="stepmsg">支付开店服务和首期费</p>
								</div>
							</div>
							<div class="linebox">
								<img src="../assets/images/icon-17.png" />
								<div class="linetit">新店筹备</div>
								<div class="stepbox">
									<p class="stepmsg">新店设计&装修</p>
									<p class="stepmsg">人员招募培训+运营全套资料</p>
									<p class="stepmsg">菜单审批，物料/设施/设备订购</p>
								</div>
							</div>
							<div class="linebox">
								<img src="../assets/images/icon-18.png" />
								<div class="linetit">新店筹备</div>

							</div>
						</div>
						<div class="formbox">
							<div class="ruletit">加盟在线申请</div>
							<div class="formmsg">感谢您对聚宝源品牌的关注和支持，如有意愿加盟聚宝源品牌，请填写书面申请，提供以下信息3个工作日内我们会电话和您洽谈。（*号为必填）</div>
							<div class="formcontent">
								<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="20px" class="demo-ruleForm">
								  <el-form-item label=" " prop="name">
								    <el-input v-model="ruleForm.name" placeholder="您的姓名"></el-input>
								  </el-form-item>
								  <el-form-item label=" " prop="tel">
								    <el-input v-model="ruleForm.tel" placeholder="联系电话"></el-input>
								  </el-form-item>
								  <el-form-item label=" " prop="email">
								    <el-input v-model="ruleForm.email" placeholder="E-mail"></el-input>
								  </el-form-item>
								  <el-form-item label=" " prop="city">
								    <el-input v-model="ruleForm.city"placeholder="意向加盟的城市"></el-input>
								  </el-form-item>
								  <el-form-item label=" " prop="cost">
								    <el-input v-model="ruleForm.cost" placeholder="预期投资金额:200-400(万元)"></el-input>
								  </el-form-item>
								  <el-form-item label=" " prop="describe">
								    <el-input type="textarea" :rows="4" v-model="ruleForm.describe" placeholder="最近从事的职业(请从简描述)"></el-input>
								  </el-form-item>
								  <el-form-item>
								     <el-button @click="submit('ruleForm')">提&nbsp;&nbsp;&nbsp;交</el-button>
								   </el-form-item>
								</el-form>
							</div>

						</div>
					</div>-->
				</el-tab-pane>
        <div class="waptit">
          <h2 v-text="pageTitle">成为合作商</h2>
          <p v-text="pageTitleEn">BECOME A FRANCHISEE</p>
        </div>

                <div>
                    <!--<div class="ruletit">加盟规则</div>-->
                    <div class="rulecontent">
                        <img :src="item" v-for="item in detail.pc_rule_images" width="100%" v-if="cliwdth>750">
                        <img :src="item" v-for="item in detail.wap_rules_images" v-if="cliwdth<=750">


                        <!--<img :src="detail.pc_rule_images" v-if="cliwdth>750" width="100%">-->
                        <!--<img :src="detail.wap_rules_images" v-else>-->
                    </div>
                </div>
                <div class="boxmarg">
                    <!--<div class="ruletit">加盟流程</div>-->
                    <div class="joinline">
                        <img :src="item" v-if="cliwdth>750" v-for="item in detail.pc_process_images" width="100%">
                        <img :src="item" v-for="item in detail.wap_process_images" v-if="cliwdth<=750">
                         <!--<img :src="detail.pc_process_images" v-if="cliwdth>750" width="100%">-->
                         <!--<img :src="detail.wap_process_images" v-else>-->
                    </div>
                    <div class="formbox">
                        <div class="ruletit">聚宝源商务合作</div>
                        <div class="formmsg" v-text="detail.brief">您好，我们是北京聚宝源饮食管理有限公司，请留下您的个人联系方式，我们会有专业的商务合作经理与您联系，感谢您对聚宝源的信任与支持！。（*号为必填）</div>
                        <div class="formcontent">
                            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="20px" class="demo-ruleForm">

                                <el-form-item label=" " prop="name">
                                    <h2>1.姓名</h2>
                                    <el-input v-model="ruleForm.name" placeholder="您的姓名"></el-input>
                                </el-form-item>
                                <el-form-item label=" " prop="tel">
                                    <h2>2.电话</h2>
                                    <el-input v-model="ruleForm.tel" placeholder="联系电话"></el-input>
                                </el-form-item>
                                <el-form-item label=" " prop="email">
                                    <h2>3.E-mail</h2>
                                    <el-input v-model="ruleForm.email" placeholder="E-mail"></el-input>
                                </el-form-item>
                                <el-form-item label=" " prop="city">
                                    <h2>4.城市</h2>
                                    <el-input v-model="ruleForm.city"placeholder="意向加盟的城市"></el-input>
                                </el-form-item>
                                <el-form-item label=" " prop="cost">
                                    <h2>5.预期</h2>
                                    <el-input v-model="ruleForm.cost" placeholder="预期投资金额:200-400(万元)"></el-input>
                                </el-form-item>
                                <el-form-item label=" " prop="describe">
                                    <h2>6.职业</h2>
                                    <el-input type="textarea" :rows="4" v-model="ruleForm.describe" placeholder="最近从事的职业(请从简描述)"></el-input>
                                </el-form-item>
                                <el-form-item>
                                    <el-button @click="submit('ruleForm')">提&nbsp;&nbsp;&nbsp;交</el-button>
                                </el-form-item>
                            </el-form>
                        </div>

                    </div>
                </div>
			</el-tabs>
		</div>
	</div>
</template>

<script>
export default {
    name: 'partner',
    data () {
        return {
			cliwdth:document.body.clientWidth,
            pageName:'ranchisee',
            pageTitle:'',
            pageTitleEn:'',
            banner:[],
            detail:{wap_rules_images : []},
            cat_id_list:
                [{cat_id:1,name:'ranchisee',title:'成为合作商',title_en:'BECOME A FRANCHISEE'},
                {cat_id:3,name:'distributor',title:'成为经销商',title_en:'BECOME A DISTRIBUTOR'},
                {cat_id:2,name:'supplier',title:'成为供应商',title_en:'BECOME A SUPPLIER'}],
            ruleForm: {
                cat_id: '',
                name: '',
                tel: '',
                email: '',
                city: '',
                cost: '',
                describe: '',
            },
            rules: {
                name: [
                    { required: true, message: '请输入您的姓名', trigger: 'blur' },
                ],
                tel: [
                    { required: true, message: '请输入您的联系方式', trigger: 'blur' },
                ],
                email: [
                    { required: true, message: '请输入您的Email', trigger: 'blur' },
                ],
                cost: [
                    { required: true, message: '请输入预期投资金额', trigger: 'blur' },
                ],
                city: [
                    { required: true, message: '请输入意向加盟的城市', trigger: 'blur' },
                ],
                describe: [
                    { required: true, message: '请输入最近从事的职业（请从简描述）', trigger: 'blur' },
                ],
            }
        }
    },
    watch:{
        $route(val){
            this.pageName = val.params.id;
            this.handleChange();
            console.log(this.pageName)
        }
    },
    mounted() {
        /* 窗口大小实时监听 */
        window.onresize = () => {
            window.screenWidth = document.body.clientWidth;
            this.cliwdth = window.screenWidth;

        };
        this.$nextTick(()=>{
            this.pageName = this.$route.params.id;
        });
        this.getBanner();

        this.handleChange();
    },
    methods:{
        handleClick(val){
//            console.log(val);console.log(val.index);
            this.pageName = this.cat_id_list[val.index].name;
            this.ruleForm.cat_id = this.cat_id_list[val.index].cat_id;
            this.pageTitle = this.cat_id_list[val.index].title;
            this.pageTitleEn = this.cat_id_list[val.index].title_en;
            this.getPartnerCat();
        },
        getBanner: async function () {
            const res = await this.$getJSON('/index/banner',{cat_id:9});
            this.banner = res.data.detail;
        },
        handleChange: async function() {
            for (let i=0;i<this.cat_id_list.length;i++) {
                let catObj = this.cat_id_list[i];console.log(catObj.name == this.pageName);
                if(catObj.name == this.pageName) {
                    this.ruleForm.cat_id = catObj.cat_id;
                    this.pageTitle = catObj.title;
                    this.pageTitleEn = catObj.title_en;
                    break;
                }
            }
            this.getPartnerCat();
        },
        getPartnerCat: async function () {
            const res = await this.$getJSON('/index/partnerCat',{id:this.ruleForm.cat_id});
            this.detail = res.data.detail;
        },
        postData: async function () {
            const res = await this.$postJSON('/index/partnerSave',this.ruleForm);
            let msg = res.msg;
			this.$message({
			          message: msg,
			          type: 'success'
			        });

        },
        submit: async function(formName){
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.postData();
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        }
    }
}
</script>

<style scoped>
	.joinus{
		padding-top: 20px;
	}
	.formcontent /deep/ .el-button {
		background: #b59f9a;
		color: #eceef3;
        padding: 9px 26px;
        font-size: 18px;
        margin: 0 auto;
        display: inherit;
	}
	.formcontent /deep/ .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before {
	    content: '*';
	    font-size: 26px;
	    color:red;
	    margin-right: 4px;
		line-height: 58px;
	}
	.formcontent /deep/ .el-input__inner {
	    background-color: #fff;
	    color: #606266;
	    height: 50px;
	    line-height: 50px;
		}
	.formcontent /deep/ .el-textarea__inner{
		background-color: #fff;
		}
	.formcontent{
		width: 600px;
		margin: 50px auto;
	}
	.formmsg{
		width: 760px;
		margin: 0px auto;
		letter-spacing: 1px;
		font-size: 17px;
		line-height: 30px;
    padding-bottom: 40px;
    border-bottom:1px dashed #ddd;
	}
	.linebox{
		vertical-align: top;
		width: 19.5%;
		display: inline-block;
		margin-bottom: 30px;
		text-align: center;
	}
	.linebox img{

	}
	.stepmsg{
		line-height: 40px;
		font-size: 17px;
	}
	.linetit{
		line-height: 70px;
		font-size: 26px;
		letter-spacing: 2px;
	}
	.joinline{
		position: relative;
		text-align: left;
	}
	.stepLine{
		position: absolute;
		width: 80px;
		height: 1px;
		top: 76px;
		background-color: #a79483;
	}
	.stepLine1{
		left: 190px;
	}
	.stepLine2{
		left: 442px;
	}
	.stepLine3{
		left: 672px;
	}
	.stepLine4{
		left: 910px;
	}

	.boxmarg{
		margin-top: 30px;
	}
	.ruletit{
		font-size: 40px;
		letter-spacing: 2px;
		line-height: 180px;
    text-align: center;
    color: #1ea0fa;
	}
	.rulecontent{
		position: relative;
		width: 100%;
	}
	.pline1{
		position: absolute;
		width: 100%;
		height: 1px;
		top: 280px;
		background-color: #eaeaea;
	}
	.pline3{
		position: absolute;
		height: 500px;
		width: 1px;
		left: 33%;
		background-color: #eaeaea;
	}
	.pline2{
		position: absolute;
		height: 500px;
		width: 1px;
		left: 66%;
		background-color: #eaeaea;
	}
	.rulemsg{
		height: 70px;
		overflow: hidden;
		text-align: center;
		font-size: 22px;
		line-height: 38px;
		letter-spacing: 2px;
	}
	.rulebox{
		padding: 30px 70px;
		width: 33%;
		height: 280px;
		box-sizing: border-box;
	}
	.rulebox img{
		margin:20px 30px;
	}
	.jubannerimg img{
		width: 100%;
	}
</style>



// WEBPACK FOOTER //
// src/vew/partner.vue